// extracted by mini-css-extract-plugin
module.exports = {"TopMarks":"marks_TopMarks__KbYND"};